import React from 'react';
import './Section.styles.scss';
import { SectionProps } from './Section.logic';

const Section: React.FC<SectionProps> = ({
  theme = 'light',
  className,
  bgName,
  children,
}) => {
  const bgClass = bgName ? `bg-${bgName}` : ''; // Dynamically set background class

  return (
    <section
      className={`section section-theme-${theme} ${bgClass} ${className || ''}`}
    >
      {children}
    </section>
  );
};

export default Section;
